import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import { SvgIconProps } from "@mui/material";
import { PermissionType } from "../../../Core/Api/Types/permission-type";

const PermissionIcon = ({ permission, ...otherProps }: { permission: PermissionType } & SvgIconProps) => {
  switch (permission) {
    case PermissionType.Access:
      return <VisibilityOutlinedIcon {...otherProps} />;
    case PermissionType.Comment:
      return <CommentOutlinedIcon {...otherProps} />;
    case PermissionType.CreateObject:
      return <FileUploadOutlinedIcon {...otherProps} />;
    case PermissionType.Download:
      return <FileDownloadOutlinedIcon {...otherProps} />;
    case PermissionType.MetadataEdit:
      return <EditOutlinedIcon {...otherProps} />;
    case PermissionType.Share:
      return <VpnKeyOutlinedIcon {...otherProps} />;
    case PermissionType.Trash:
      return <DeleteOutlineOutlinedIcon {...otherProps} />;
    default:
      return null;
  }
};

export default PermissionIcon;
